import * as React from 'react';
import { HtmlHeadInclude } from '@msdyn365-commerce/core';

const isDev = false; // process.env.NODE_ENV === 'development';

type SharedScriptsProps = {
    googleTagManagerId?: string;
    bazaarVoiceEnv?: string;
    locale: string;
};

const SharedScripts = ({ googleTagManagerId, bazaarVoiceEnv, locale }: SharedScriptsProps) => {
    const bvLocale = (locale || 'en-CA').replace('-', '_');
    const bvScript = `https://apps.bazaarvoice.com/deployments/henrys/main_site/${bazaarVoiceEnv || 'staging'}/${bvLocale}/bv.js`;

    const bvHandlerScript = `
window.bvCallback = function (BV) {
    BV.reviews.on('show', function () {
        var elem = document.getElementsByClassName("hei-bv-reviews")[0];
        elem && elem.click();
    });
}
    `;

    React.useEffect(() => {
        if (googleTagManagerId && !isDev) {
            (function(w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s) as HTMLScriptElement,
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode?.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', googleTagManagerId);
        }
    }, [googleTagManagerId]);

    // if (isDev) {
    //     React.useEffect(() => {
    //         const bodyTag = document.getElementsByTagName('body')[0];

    //         const script = document.createElement('script');
    //         script.async = true;
    //         script.src = `/assets/gtm.js`;
    //         bodyTag.appendChild(script);
    //     }, []);
    // }

    return (
        <>
            <HtmlHeadInclude>
                <script data-load-point='headEnd' async src={bvScript} />

                {/* tslint:disable-next-line: react-no-dangerous-html */}
                <script data-load-point='headStart' dangerouslySetInnerHTML={{ __html: bvHandlerScript }} />
            </HtmlHeadInclude>
        </>
    );
};

export default SharedScripts;
